import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo, useRef } from 'react';
import { computeReportViews, dataAsOf } from '@tallyframe/core';
import { ReportGrid } from './internal/ReportGrid.js';
import { ReportHeader } from './internal/ReportHeader.js';
/**
 * The editable dashboard.
 *
 * It owns no state that matters: a drag or a resize leaves as a single
 * `set_layout` operation and the host decides whether it lands. Undo, redo and
 * persistence belong to the host, which is why an undone layout can be pushed
 * straight back in through `definition` and the grid will follow it without
 * echoing another operation back.
 */
export function ReportEditor(props) {
    const locale = props.locale ?? props.brand?.theme?.locale ?? 'en-US';
    const views = useMemo(() => computeReportViews(props.definition, props.data, locale), [props.definition, props.data, locale]);
    const onOperationsRef = useRef(props.onOperations);
    onOperationsRef.current = props.onOperations;
    const handleLayoutChange = useCallback((items) => {
        // One operation per gesture, carrying every placement the gesture moved —
        // float:false means dragging one widget can reflow its neighbours.
        onOperationsRef.current([{ op: 'set_layout', items }]);
    }, []);
    const header = (_jsx(ReportHeader, { title: props.definition.title, subtitle: props.definition.subtitle, preparedFor: props.definition.preparedFor, dataAsOf: dataAsOf(props.data.snapshot), brand: props.brand, selectable: true, selected: props.headerSelected, onSelect: props.onSelectHeader }));
    return (_jsx(ReportGrid, { definition: props.definition, views: views, interactive: true, selectedWidgetId: props.selectedWidgetId, onSelectWidget: props.onSelectWidget, onLayoutChange: handleLayoutChange, className: props.className, brand: props.brand, header: header }));
}
//# sourceMappingURL=ReportEditor.js.map